import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js'

const NOME_COOKIE = 'a8f31d6c2b9e4f70'
const CHAVE_CRIPTOGRAFIA = 'pontotel-contas-login-dispositivo-v1'
const TEMPO_MAXIMO_SEM_ACESSO = 30 * 24 * 60 * 60 * 1000
const TEMPO_VALIDADE_COOKIE = 30 * 24 * 60 * 60 * 1000
const LIMITE_CONTAS = 5

function normalizarEmail (email) {
  return String(email || '').trim().toLowerCase()
}

function gravarContas (contas, expiraEm) {
  if (!contas.length) {
    Cookies.remove(NOME_COOKIE, { path: '/' })
    return
  }

  const dados = { contas, expiraEm }
  const criptografado = CryptoJS.AES.encrypt(JSON.stringify(dados), CHAVE_CRIPTOGRAFIA).toString()
  Cookies.set(NOME_COOKIE, criptografado, {
    path: '/',
    sameSite: 'Lax',
    expires: new Date(expiraEm)
  })
}

function lerDadosCookie (emailEmAcesso) {
  const valorCriptografado = Cookies.get(NOME_COOKIE)
  if (!valorCriptografado) return { contas: [], expiraEm: null }

  try {
    const texto = CryptoJS.AES.decrypt(valorCriptografado, CHAVE_CRIPTOGRAFIA).toString(CryptoJS.enc.Utf8)
    const dados = JSON.parse(texto)
    const agora = Date.now()
    const contas = Array.isArray(dados) ? dados : dados?.contas
    const expiraEm = Array.isArray(dados) ? agora + TEMPO_VALIDADE_COOKIE : Number(dados?.expiraEm)
    if (!Array.isArray(contas) || !expiraEm || expiraEm <= agora) {
      Cookies.remove(NOME_COOKIE, { path: '/' })
      return { contas: [], expiraEm: null }
    }

    const contasValidas = contas
      .filter(conta => typeof conta?.email === 'string' && conta.email.includes('@'))
      .map(conta => ({
        email: normalizarEmail(conta.email),
        pendente: conta.pendente === true,
        ultimoAcesso: Number(conta.ultimoAcesso) || agora
      }))
      .filter(conta => (
        agora - conta.ultimoAcesso < TEMPO_MAXIMO_SEM_ACESSO ||
        conta.email === normalizarEmail(emailEmAcesso)
      ))
      .slice(0, LIMITE_CONTAS)

    if (contasValidas.length !== contas.length || Array.isArray(dados)) {
      gravarContas(contasValidas, expiraEm)
    }
    return { contas: contasValidas, expiraEm }
  } catch {
    Cookies.remove(NOME_COOKIE, { path: '/' })
    return { contas: [], expiraEm: null }
  }
}

export function lerContasSalvas () {
  return lerDadosCookie().contas.filter(conta => !conta.pendente)
}

export function salvarEmailPendente (email, lembrarEmail) {
  const emailNormalizado = normalizarEmail(email)
  const dadosSalvos = lerDadosCookie()
  const contas = dadosSalvos.contas
  const expiraEm = dadosSalvos.expiraEm || Date.now() + TEMPO_VALIDADE_COOKIE
  const existente = contas.find(conta => conta.email === emailNormalizado)

  if (!lembrarEmail || !emailNormalizado.includes('@')) {
    gravarContas(contas.filter(conta => conta.email !== emailNormalizado || !conta.pendente), expiraEm)
    return
  }

  if (existente && !existente.pendente) return

  const agora = Date.now()
  const demaisContas = contas.filter(conta => conta.email !== emailNormalizado)
  const contasAtualizadas = [
    { email: emailNormalizado, pendente: true, ultimoAcesso: existente?.ultimoAcesso || agora },
    ...demaisContas
  ]

  if (contasAtualizadas.length > LIMITE_CONTAS) {
    contasAtualizadas.sort((a, b) => b.ultimoAcesso - a.ultimoAcesso)
    contasAtualizadas.length = LIMITE_CONTAS
  }

  gravarContas(contasAtualizadas, expiraEm)
}

export function confirmarEmailPendente (emailLogado) {
  try {
    const emailNormalizado = normalizarEmail(emailLogado)
    const dadosSalvos = lerDadosCookie(emailNormalizado)
    const contasPendentes = dadosSalvos.contas.filter(conta => conta.pendente)
    const confirmouEmail = contasPendentes.some(conta => conta.email === emailNormalizado)
    const agora = Date.now()
    const contasAtualizadas = dadosSalvos.contas
      .filter(conta => !conta.pendente || conta.email === emailNormalizado)
      .map(conta => conta.pendente
        ? { email: conta.email, pendente: false, ultimoAcesso: agora }
        : conta.email === emailNormalizado
          ? { ...conta, ultimoAcesso: agora }
          : conta)

    gravarContas(contasAtualizadas, agora + TEMPO_VALIDADE_COOKIE)
    return confirmouEmail
  } catch { }
}

export function removerContaSalva (email) {
  const emailNormalizado = normalizarEmail(email)
  const dadosSalvos = lerDadosCookie()
  gravarContas(
    dadosSalvos.contas.filter(conta => conta.email !== emailNormalizado),
    dadosSalvos.expiraEm
  )
}
